import type { PageElementData } from "../../@types/viewerati";
import { PageSizeAtom } from "../../state/page";
import type { RefObject } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { useRecoilValue } from "recoil";
gsap.registerPlugin(useGSAP)

function useAiAnimation({ elRef, modifier }: { elRef: RefObject<HTMLDivElement>, modifier: PageElementData['modifier'] }) {
    const pageSize = useRecoilValue(PageSizeAtom)
    // //console.log("useAiAnimation")
    useGSAP(() => {
        if (elRef.current) {
            const x = modifier?.["across:"];
            const y = modifier?.["down:"];
            const originX = elRef.current.offsetLeft
            const originY = elRef.current.offsetTop
            if (x && y && pageSize.onePercentHeight && pageSize.onePercentWidth) {
                const xValue = Number.parseInt(x) * pageSize.onePercentWidth
                const yValue = Number.parseInt(y) * pageSize.onePercentHeight
                gsap.set(elRef.current, { position: "absolute", left: originX, top: originY })
                gsap.to(elRef.current, { left: xValue, top: yValue, duration: .35, ease: "power1.out" })
            }
            // gsap.to(elRef.current, { x: 0, autoAlpha: 1, duration: 40 })
            // masterTimeline?.add(tween, atomId * 3)
        }


    }, { dependencies: [modifier], revertOnUpdate: false })


}


export default useAiAnimation